import { render } from "./EditBusinessRuleActionUpdateRecord.vue?vue&type=template&id=1725e290"
import script from "./EditBusinessRuleActionUpdateRecord.vue?vue&type=script&lang=js"
export * from "./EditBusinessRuleActionUpdateRecord.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__